import axios from "axios";

const API_URL = "/api/holidays";

/** Optional { from, to } ISO dates — returns anything overlapping that range. */
export const getHolidays = async (params = {}) => {
  const res = await axios.get(API_URL, { params });
  return res.data;
};

export const createHoliday = async (payload) => {
  const res = await axios.post(API_URL, payload);
  return res.data;
};

export const updateHoliday = async (id, payload) => {
  const res = await axios.put(`${API_URL}/${id}`, payload);
  return res.data;
};

export const deleteHoliday = async (id) => {
  const res = await axios.delete(`${API_URL}/${id}`);
  return res.data;
};

/** Recompute every term's weeks from the current calendar. */
export const resyncTermWeeks = async () => {
  const res = await axios.post(`${API_URL}/resync`);
  return res.data;
};
